import React from 'react';
import { render } from 'react-dom';
import { ready } from 'core-utilities';
import App from './App';
import '../../../css/paymentSystemUnavailable/paymentSystemUnavailable.scss';

const rootElementId = 'payment-system-unavailable-container';

ready(() => {
  render(<App />, document.getElementById(rootElementId));
});
